module.exports = __webpack_public_path__ + "assets/ic_no_badge.5e09782f.svg";